module.exports = __webpack_public_path__ + "static/Cruzadas-689a4fa86e05aa46274f8c072add4ca3.jpg";